import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {shadows} from '../../../styles/shadowStyles';

/*
 * Props.
 */

interface TooltipContentWrapperProps {
  children: ReactNode;
  borderRadius: string;
}

/*
 * Constants.
 */

const tooltipMaxWidth = 240;

/*
 * Style.
 */

const StyledDiv = styled.div<{$borderRadius: string}>`
  background-color: ${(p) => p.theme.tooltip.background};
  color: ${(p) => p.theme.tooltip.text};
  ${shadows.tooltip};

  max-width: ${tooltipMaxWidth}px;
  width: fit-content;
  border-radius: ${(p) => p.$borderRadius};
`;

/*
 * Component.
 */

export const TooltipContentWrapper: FC<TooltipContentWrapperProps> = ({children, borderRadius}) => (
  <StyledDiv $borderRadius={borderRadius}>{children}</StyledDiv>
);
